import { useRouteResources } from '@lp/features/RoutePlanner/hooks/useRouteResources';
import { getLegCrewTitle } from '@lp/features/CaseOverview/components/Tabs/AssignedResources/utils';
import { AviaLegTypes, GroundLegTypes, RouteLegTypeEnum } from '@/api/apis/route';
import { CaseResourceType } from '@/api/apis/case';
import { getFullName } from '@/utils/helpers';
import { CrewMemberCard } from './CrewMemberCard';
import { CrewMemberGroundCard } from './CrewMemberGroundCard';
import { GroundTripDriverCard } from './GroundTripDriverCard';

type TransportResourcesProps = {
  leg: AviaLegTypes | GroundLegTypes;
};

export const TransportResources = ({ leg }: TransportResourcesProps) => {
  const { Crew: crewList } = useRouteResources();

  switch (leg.legType) {
    case RouteLegTypeEnum.TmdxJetAviaLeg:
      const crewOnLeg = leg.resources.filter((r) => r.resourceType === CaseResourceType.Crew).map((r) => r.resourceId);

      if (!crewOnLeg.length) return null;

      const crewResources = crewList.filter((r) => crewOnLeg.includes(r.resourceId));

      return crewResources.map((crew) => {
        const fullName = getFullName(crew.firstName, crew.lastName);

        return (
          <CrewMemberCard
            key={crew.resourceId}
            title={fullName}
            subTitle={getLegCrewTitle(leg.legType)}
            showChip={false}
          />
        );
      });
    case RouteLegTypeEnum.SupplementalLiftAviaLeg:
    case RouteLegTypeEnum.TxCenterProviderAviaLeg:
      const firstCrewMemberName = getFullName(leg.firstCrewMember.firstName, leg.firstCrewMember.lastName);
      const secondCrewMemberName = getFullName(leg.secondCrewMember.firstName, leg.secondCrewMember.lastName);

      return (
        <>
          {!!firstCrewMemberName && (
            <CrewMemberCard title={firstCrewMemberName} subTitle={getLegCrewTitle(leg.legType)} showChip={false} />
          )}
          {!!secondCrewMemberName && (
            <CrewMemberCard title={secondCrewMemberName} subTitle={getLegCrewTitle(leg.legType)} showChip={false} />
          )}
        </>
      );
    case RouteLegTypeEnum.TmdxAffiliateGroundLeg:
    case RouteLegTypeEnum.TxCenterProviderGroundLeg:
      return leg.driver ? (
        <CrewMemberGroundCard title={leg.driver || ''} subTitle={getLegCrewTitle(leg.legType)} />
      ) : null;
    case RouteLegTypeEnum.TmdxDriveAffiliateGroundLeg:
    case RouteLegTypeEnum.TmdxDriveTedsGroundLeg:
      return leg.tripReference?.tripId ? (
        <GroundTripDriverCard tripId={leg.tripReference.tripId} legType={leg.legType} />
      ) : null;
    default:
      return null;
  }
};
